import { render } from "./App.vue?vue&type=template&id=fd78aad8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=fd78aad8&lang=css"
script.render = render

export default script